<template>
  <div class="dataInterval-item mb8">
    <div class="auto-fresh mb8">
      <el-checkbox v-model="autoUpdate">自动更新数据</el-checkbox>
    </div>
    <div v-if="autoUpdate" class="fresh-setting">
      <span>每隔</span>
      <single-input
        class="mr16"
        style="width: 88px; margin-left: 8px; margin-right: 8px"
        :value.sync="updateTimer"
        :min="min"
        :max="max"
        :step="step"
        :noInputSuffixs="true"
      />
      <span>{{ unit }}更新一次</span>
    </div>
    <div class="mt12" v-if="showPersonalData && isNotCell">
      <div class="verticallyCenter">
        <cx-check-box class="auto-fresh"  :is-disabled="isOpenPagination" :value.sync="personalData">实时数据</cx-check-box>
        <i class="tips-btn icon-portal-info2 mt4" @click.stop.prevent="explainDialogClick(1)"></i>
      </div>
      <div class="verticallyCenter mt12" v-if="personalData">
        <cx-check-box class="height20" :value.sync="openBrowserQs">链接参数传递</cx-check-box>
        <i class="tips-btn icon-portal-info2 mt4" @click.stop.prevent="explainDialogClick(2)"></i>
      </div>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span v-if="explainObject.explainTitle">{{ explainObject.explainTitle }}：</span>{{ explainObject.explainTips }}
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify"
import { isExist } from "utils"

export default {
  name: "autoUpdateTimer",
  props: {
    options: { type: Object },
    defaultPeriod: { type: Number, default: 600 },
    unit: { type: String, default: "秒" },
    // 图表类型或者普通类型数据
    type: {
      type: String,
      default: "general"
    },
    isLocal: {
      type:Boolean
    },
    isOpenPagination:{
      type:Boolean
    },
    step: {
      type: Number,
      default: 1,
    },
    minVal: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      this1: this,
      explainDialog:false,
      explainObject:{}
    }
  },
  computed: {
    isNotCell(){
      // 判断是否再单元格
      return !(this.ids.uid && !isExist(this.ids.elementInLayoutId)) && !(isExist(this.ids.swiperContent_id) && !isExist(this.ids.elementInSwiperId))
    },
    ids() {
      return this.$store.state.states.activeID
    },
    appId(){
      return this.getOptions.appId ? this.getOptions.appId :  this.getOptions.myFetchParam?.appId
    },
    getOptions: function () {
      const attr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      return this.options || attr.options || attr
    },
    updateTimer: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "updateTimer", "updateTimer", this.defaultPeriod)
      },
      set(newVal) {
        if (newVal) {
          newVal = Number(newVal) > this.max ? this.max : newVal
          this.$changeOptionsEV(this.step === 0.1 ? Number(newVal.toFixed(1)) : newVal, "updateTimer", false, null, this.ids)
        }
      }
    },
    autoUpdate: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "autoUpdate", "autoUpdate", this.isBigScreen)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "autoUpdate", false, null, this.ids)
      }
    },
    showPersonalData(){
      // 图文不管是本地数据还是外接数据都显示实时数据
      if((typeof this.isLocal === 'boolean' && !this.isLocal) || this.options?.innerElement === "emptyLayoutComponent"){
        return true
      }
    },
    personalData:{
      get() {
        return this.getOptions.personalData || false
      },
      set(newVal) {
        this.setPersonalData(newVal)
      }
    },
    openBrowserQs:{
      get() {
        return this.getOptions.openBrowserQs || false
      },
      set(newVal) {
        this.setOpenBrowserQs(newVal)
      }
    },
    isBigScreen() {
      return location.href.indexOf("bigScreen") > -1
    },
    min() {
      return this.isBigScreen ? 5 : this.minVal
    },
    max() {
      return 999999
    }
  },
  watch:{
    appId(oldVal,newVal){
      if(oldVal){
        this.getEngineInstanceInfo()
      }
    }
  },
  mounted(){
    this.getEngineInstanceInfo()
    this.$eventBus.$on("data-center-change", this.getEngineInstanceInfo)
  },
  beforeDestroy(){
    this.$eventBus.$off("data-center-change", this.getEngineInstanceInfo)
  },
  methods:{
    getEngineInstanceInfo(){
      if(!this.appId){
        return
      }
      if(!this.getOptions.hasOwnProperty("personalData") || !this.getOptions.hasOwnProperty("moreInfo")){
        const {pageId,websiteId} = this.$store.state.states.getDataPageIds
        this.$API
          .getEngineInstance({
              appId: this.appId,
              pageId: pageId,
              websiteId:websiteId
          })
          .then(res => {
            if (res.data.code === 1) {
              const personalData = res.data.data.personalData
              const openBrowserQs =  res.data.data.moreInfo ? JSON.parse(res.data.data.moreInfo)?.openBrowserQs :false
              this.$changeOptionsEV([personalData,openBrowserQs], ["personalData","openBrowserQs"], false, null, {...this.ids}, true)
            }
          })
      }
    },
    async setOpenBrowserQs(newVal){
      let engineInstanceId = this.getOptions.engineInstanceId
      const appId = this.getOptions.appId ? this.getOptions.appId :  this.getOptions.myFetchParam?.appId
      if(!engineInstanceId){
        engineInstanceId = await this.getEngineInstanceId(appId)
      }
      this.$API
        .updateAppAttr({
          param: {
            publicId: engineInstanceId,
            openBrowserQs: newVal
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.$changeOptionsEV(newVal, "openBrowserQs", false, null, {...this.ids},false)
          }
        })
    },
    async setPersonalData(newVal){
      this.$changeOptionsEV(false, "personalData", false, null, {...this.ids},false)
      let engineInstanceId = this.getOptions.engineInstanceId
      if(!engineInstanceId){
        engineInstanceId = await this.getEngineInstanceId()
      }
      this.$API
        .updateAppAttr({
          param: {
            publicId: engineInstanceId,
            person: newVal
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.$changeOptionsEV(newVal, "personalData", false, null, {...this.ids},false)
          }
        })
    },
    async getEngineInstanceId(){
      if(!this.appId){
        return
      }
      let engineInstanceId
      if(this.type === "chart_screen"){
        const res = await this.$API.getContentConfig({ appId: this.appId, engineType: this.type })
        engineInstanceId = res.data.data.engineInstance?.publicId
      }else{
        const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
        const res = await getAppointCacheData.call(this, pageId, wfwfid, websiteId, this.appId)
        engineInstanceId = res?.engineInstanceId
      }
      return engineInstanceId
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainObject = {
            explainTitle:"",
            explainTips:"开启后，每次刷新页面或自动更新数据，都会获取最新数据。\n" +
              "注：如果开启了分页组件，数据实时默认开启"
          }
          break
        case 2:
          this.explainObject = {
            explainTitle:"",
            explainTips:"可以将网址链接中的参数传递给数据源"
          }
          break
        default:
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.bigScreen-toolbar {
  .dataInterval-item {
    .fresh-setting {
      background-color: #2c2f33;
      border: solid 1px #373737;
    }
  }
}
.dataInterval-item {
  .auto-fresh,
  .height20 {
    height: 20px;
  }
  .fresh-setting {
    height: 56px;
    border: 1px solid #e9e9e9;
    padding: 12px;
    display: flex;
    align-items: center;
    border-radius: 4px;
  }
}
::v-deep.dataInterval-item .el-checkbox__label {
  color: var(--subTextColor) !important;
}
.ml24 {
  margin-left: 24px;
}
</style>
